


















































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapState, mapActions } from 'vuex';

import { STORE_KEY, store } from './_store';

import TitleBar from '@/components/Elements/TitleBar.vue'
import cloneDeep from 'lodash/cloneDeep';

import VocabularyManagerForm from './VocabularyManagerForm/VocabularyManagerForm.vue'

@Component({
  computed: {
    ...mapState(STORE_KEY, [
      'loading', 'loaded', 'fatalError',

      'filter',

      'documents', 'lastMeta', 'params'
    ]),
  },
  components: {
    TitleBar
  }
})
export default class VocabularyManager extends Vue {
  radioButton = 1;
  params!: any;

  titleStack: string[] = [];

  get queryParams() {
    return cloneDeep(this.$route.query);
  }

  get defaultSort() {
    return [this.$route.query.sortField || 'name', this.$route.query.sortDirection || 'asc']
  }

  get selectedView() {
    return this.$route.query.view || 'linked'
  }

  setFilter(filterName: string, filterValue: any) {
    this.$router.replace({
      query: {
        ...this.$route.query,
        [filterName]: filterValue
      }
    })
  }

  onSort(field: string, direction: string) {
    console.log('onSort', field, direction)
    this.$router.replace({
      query: {
        ...this.$route.query, sortField: field, sortDirection: direction
      }
    })
  }

  private delayFilter: any = null
  private delayFilterValue: any = null

  onSearch(filter: string, value: any) {
    if (!this.delayFilter) {
      setTimeout(() => {
        this.$router.replace({
      query: {
        ...this.$route.query, [this.delayFilter]: this.delayFilterValue
      }
    })
        this.delayFilter = null
      }, 3000)
    }
    this.delayFilter = filter
    this.delayFilterValue = value
  }

  onPageChange(page: string) {
    console.log('onPageChange', page)
    this.$router.replace({
      query: { ...this.$route.query, page }
    })
  }

  openDocument(row: any) {
    this.$buefy.modal.open({
      component: VocabularyManagerForm,
      props: {
        isNew: !row || !row.id,
        documentPreview: row,
        table: this.params.table,
        ignore_fields: this.params.ignore_fields,
        valueField: this.params.value_field,
        initParams: {
          color: '#ffffff',
          ...(this.params.value_field ? { [this.params.value_field.field]: 0 } : {})
        }
      },
      events: {
        'form-close': () => {
          this.handleParamsChange();
        },
      },
      hasModalCard: true,
      fullScreen: true,
      customClass: 'document-form short-form',
      parent: this
    })
  }

  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  }

  public mounted() {
    this.handleParamsChange();
  }

  beforeDestroy() {
    this.$store.unregisterModule(STORE_KEY);
  }

  // ---------------------------------------------------------------------------

  @Watch('$route.query')
  public handleParamsChange() {
    this.$store.dispatch(`${STORE_KEY}/setParams`, this.$route.params)
    this.$store.dispatch(`${STORE_KEY}/loadData`, this.$route.query).then(() => {
      this.titleStack = [
      'Настройки', 'Словари', this.params.name
    ]
    })
  }

}
